
import React, { Component } from "react";
//import "../../antdstyle.css";
//import "antd/dist/antd.css";

import BusinessSummarySheet from "./BusinessSummarySheet";
import CompanyBankStatement from "./CompanyBankStatement";
import CompanyDocs from "./CompanyDocs";
import CompanyITR from "./CompanyITR";

import { documentSectionMap } from "./dynamic_documents";
import mixins from "../mixins";
import dynamicDocumentsFunc from "./dynamic_documents";
const components = {
  CompanyDocs,
  CompanyITR,
  CompanyBankStatement,
  BusinessSummarySheet
};
class CreditDocUploads extends Component {
  constructor(props) {
    super(props);
    props.initialconstruct.bind(this)("CreditDocUploads");
    this.links = mixins.links;
    let firmType = this.mixin.companyType();
    this.state = {
      firmType,
      data: {},
      docList: [],
      active: 1,
    };
    this.documentSectionMap = documentSectionMap(firmType);
  }

  getDocumentsAll() {
    return new Promise((resolve, reject) => {
      this.api.apiGetApplicationDocumentsAll().then((list) => {
        app.store(`uploads.credit`,{});
        console.log({uploads:list});
        (list.credit || []).map((item)=>{
          let { group, documentKey, name } = item.doc_meta_name;
          app.store(`uploads.${group}.${documentKey}.${name}`,{
            isuploaded: true,
            "data-invalue": item['attachment_id'],
            "data-filename": item['file_name'],
            labelname: item['file_name'],
            password:item['password']
          });
        });
        this.setState((state) => ({
          docList: (list.credit || [])
        }), () => resolve(list.profile));
      }).catch(() => {
        this.setState((state) => ({
          docList: []
        }), () => resolve([]));
      });
    })
  }

  getCompanyData() {
    this.api.execApi("getCompanyDoc", {}, {
      firm_type: this.state.firmType
    }, {
      onexec: (response) => {
        this.store(`credit.remote.company-doc`, response.data)
      },
      onfailure: () => {
        this.store(`credit.remote.company-doc`, null);
      }
    });
  }

  getBankStatements() {
    this.api.execApi("getBankStatement", {}, {
      firm_type: this.state.firmType
    }, {
      onexec: (response) => {
        this.store(`credit.remote.bank-statements`, response.data.items);
      },
      onfailure: () => {
        this.store(`credit.remote.bank-statements`, null);
      }
    });
  }

  getCompanyITRData() {
    this.api.execApi("getCompanyItr", {}, {
      firm_type: this.state.firmType
    }, {
      onexec: (response) => {
        this.store(`credit.remote.company-itr`, response.data);
      },
      onfailure: () => {
        this.store(`credit.remote.company-itr`, null);
      }
    });
  }

  getBankSummary() {
    let doclistpromise = enums.docTypes.map((type) => this.api.execApi("getBusinessSummaryTemplate", {}, {
      doc_type: type
    }));
    let summarySheets = this.props.store?.credit?.remote['summary-sheets'];
    summarySheets = (!summarySheets || typeof summarySheets !== "object") ? {} : summarySheets;
    this.store(`credit.remote.summary-sheets`, summarySheets);
    Promise.all(doclistpromise).then((response) => {
      enums.docTypes.map((type, i) => {
        this.store(`credit.remote.summary-sheets.${type}`, !!response[i]);
      })
    });
  }

  getGSTInfo() {
    this.api.execApi("getGstInfo", {},{},{
      onexec: (response) => {
        let statenames = response.data.items.group('state_name');
        this.store(`credit.remote.gst-info.state`, Object.values(statenames).map(statement=>({
          state_name:statement[0].state_name,
          gstin_id:statement[0].gstin_id,
          id:statement[0]._id,
          months:statement
        })));
      },
      onfailure: () => {
        this.store(`credit.remote.gst-info.state`, []);
      }
    });
  }

  getSanctionLetter() {
    this.api.execApi("getSanctionLetter", {},{},{
      onexec: (response) => {
        this.store(`credit.remote.sanction-letter.letters`,response.data.items);
      },
      onfailure: () => {
        this.store(`credit.remote.sanction-letter.letters`, []);
      }
    });
  }

  getFetchDocData(key = "") {
    return new Promise(async (resolve, reject) => {

      switch (key) {
        case "company-doc": return this.getCompanyData();
        case "company-itr": return this.getCompanyITRData();
        case "summary-sheets": return this.getBankSummary();
        case "bank-statements": return this.getBankStatements();
        case "gst-info": return this.getGSTInfo();
        case "sanction-letter": return this.getSanctionLetter();
        default:
          let loaded = loader("Loading data please wait..");
          await this.getCompanyData();
          await this.getCompanyITRData();
          await this.getBankSummary();
          await this.getBankStatements();
          await this.getGSTInfo();
          await this.getSanctionLetter();
          setTimeout(() => {
            loaded.close();
          });
      }
      resolve();
    });

  }

  componentDidMount() {
    console.log({});
    this.getDocumentsAll();
    this.getFetchDocData();
    this.setState({
      docList: []
    });
  }
  renderAccordian(accordian, key) {
    let { state } = this;
    return <accordian.component
      edit={!!state.data[key]}
      data={state.data[key]}
      docList={(state.docList || []).group('doc_meta_name.documentKey')}
      onFetchDocList={() => this.getDocumentsAll()}
      onInfoList={() => this.getFetchDocData(key)}
      firmType={state.firmType}
      documentKey={key}
    >
    </accordian.component>
  }
  render() {
    let { props, state, documentSectionMap } = this;
    let { active = 1 } = this.state;
    return (
      <AppWrapper title="Docs Upload" back="Credits" backlink="/app/credit_list" >
        <AppLinkTabs data={this.links}></AppLinkTabs>
        <div className="container-fluid paper_container">
          <AppAccordian
            active={this.appstore('credit.active')}
            onActive={(active) => this.store('credit.active', active)}
            data={Object.entries(documentSectionMap).map(([key, value]) => ({
              Title: value.title && (() => value.title),
              Content: value.component && (() => this.renderAccordian(value, key)),
            }))}
          ></AppAccordian>
        </div>
      </AppWrapper>
    );
  }
}

export default connect(CreditDocUploads);